import { Box, Stack, Typography, useTheme } from "@mui/material"
import { useTranslation } from "react-i18next";
import { useAuthContext } from "hooks/useAuthContext";

export const OrganizationInfoSection = (props: {
    organizationName: string,
    userRole: string,
    patronNames: string[],
    tagA: string,
    tagB: string
}) => {
    const { userState } = useAuthContext();
    const { t } = useTranslation();
    const theme = useTheme();

    return <Box width='100%' padding={theme.spacing(2)} height='15%'>
        <Typography variant="h6">{t('profile.yourPlaceInOrganization')}</Typography>
        <Stack direction={'row'} marginTop={2} width='100%' spacing={theme.spacing(10)}>
            <Stack>
                <Typography variant="caption">{t('general.organization')}</Typography>
                <Typography variant="subtitle1" fontWeight={'500'}>{props.organizationName ?? userState.user.selectedWorkspace.workspaceName }</Typography>
            </Stack>
            <Stack>
                <Typography variant="caption">{t('general.role')}</Typography>
                <Typography variant="subtitle1" fontWeight={'500'}>{t(`roles.${props.userRole}`)}</Typography>
            </Stack>
            <Stack>
                <Typography variant="caption">{t('general.patrons')}</Typography>
                <Stack>
                    {props.patronNames.length > 0
                    ? props.patronNames.map((name, index) => <Typography key={index} variant="subtitle1" fontWeight={'500'}>{name}</Typography>)
                    : <Typography variant="subtitle1" fontWeight={'500'}>{t('general.none')}</Typography>}
                </Stack>
            </Stack>
            <Stack>
                <Typography variant="caption">{t('general.tagA')}</Typography>
                <Typography variant="subtitle1" fontWeight={'500'}>{props.tagA || t('general.none')}</Typography>
            </Stack>
            <Stack>
                <Typography variant="caption">{t('general.tagB')}</Typography>
                <Typography variant="subtitle1" fontWeight={'500'}>{props.tagB || t('general.none')}</Typography>
            </Stack>
        </Stack>
    </Box>
}